var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 29.0625C6.50586 29.0625 0 22.5566 0 14.5312C0 6.50586 6.50586 0 14.5312 0C22.5566 0 29.0625 6.50586 29.0625 14.5312C29.0625 22.5566 22.5566 29.0625 14.5312 29.0625Z",
    fill: "#E6ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87016 23.1913C4.2254 21.3769 5.98517 19.9036 8.0096 18.8885C10.034 17.8734 12.2673 17.3445 14.532 17.3438C16.7967 17.343 19.0303 17.8706 21.0554 18.8844C23.0805 19.8982 24.8412 21.3704 26.1975 23.184C24.8481 25.0068 23.0903 26.488 21.0651 27.5088C19.0399 28.5297 16.8036 29.0618 14.5357 29.0625C12.2678 29.0632 10.0312 28.5325 8.00536 27.5129C5.97952 26.4933 4.22079 25.0132 2.87016 23.1913Z",
    fill: "#29696E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 15.4688C11.4246 15.4688 8.90625 12.9504 8.90625 9.84375C8.90625 6.73715 11.4246 4.21875 14.5312 4.21875C17.6379 4.21875 20.1562 6.73715 20.1562 9.84375C20.1562 12.9504 17.6379 15.4688 14.5312 15.4688Z",
    fill: "#29696E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.b34afd24b118e27aa528afa5018a545d.svg";
export { ForwardRef as ReactComponent };